import {PageViewTracker} from 'core/components/google-analytics';
import {useGetUserQuery} from 'generated/graphql';
import {FC} from 'react';

export const PageViewTrackerWithUserId: FC = () => {
    const {data} = useGetUserQuery();
    return <PageViewTracker userId={data?.user?.id} />;
};
